<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5 bg-grey200">
			<div class="flex-shrink-0 d-flex flex-column bg-grey200">
				<section class="inner container ">
					<div class="center-contain pt-5 text-center">
						<h1 class="pricing-heading">Pay with cash</h1>
						<small class="my-2 lead">Secure Server <i class="fa fa-lock"></i></small>
					</div>
				</section>
				<section class="login-container bg-none flex-shrink-0 container">
					<form class="form-signin card mt-4">
						<a class="close-btn" href="#">
							<img src="assets/img/close.svg" alt="" />
						</a>
						<h5 class="text-center mb-3">
							<img src="../../assets/img/museum-green.svg" alt="" width="45" />
						</h5>

						<div class="form-group text-center">
							Select your Bank of choice
						</div>
						<div class="form-group mb-4">
							<select class="custom-select border-0" v-model="currentbankid">
								<option
									:value="item.id"
									v-for="(item, index) in cashData"
									:key="index"
									>{{ item.name }}</option
								>
							</select>
						</div>
						<div class="form-group">
							<table class="table">
								<tr>
									<td>Bank</td>
									<td class="pr-2 pl-2">-</td>
									<td>{{ currentbankName }}</td>
								</tr>
								<tr>
									<td>Account Name</td>
									<td class="pr-2 pl-2">-</td>
									<td>{{ currentbankAccountName }}</td>
								</tr>
								<tr>
									<td>Account Number</td>
									<td class="pr-2 pl-2">-</td>
									<td>{{ currentbankAccountNumber }}</td>
								</tr>
							</table>
						</div>
						<p class="text-center font14">
							Visit your local branch and make a deposit to the account details
							below. Once you’ve paid, email us the payment receipt at
							support@ibakatv.com (include your Username) or Chat with us to
							activate your account.
						</p>
						<button
							class="btn btn-primary btn-block text-uppercase mt-3"
							@click="gotoSingin"
						>
							CONTINUE
						</button>
					</form>
					<p class="text-center pt-4">Download App</p>
					<p class="text-center ">
						<img
							src="../../assets/img/google-play.png"
							alt=""
							class="cursor-pointer"
							@click="gotoAppStore('google')"
						/>
						<img
							src="../../assets/img/app-store.png"
							class="ml-2 cursor-pointer"
							alt=""
							@click="gotoAppStore('apple')"
						/>
					</p>
				</section>
			</div>
		</section>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	name: "cashPayment",
	components: {},
	watch: {
		currentbankid: function(val) {
			var currentBank = this.getBankById(val);
			this.currentbankid = currentBank.id;
			this.currentbank = currentBank;
		},
	},
	created() {
		this.packages = this.$store.state.packages;
		   this.$store.commit("showPopup", false);
		// this.currentbankid = this.$route.params.paymentmethod;
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
	},

	computed: {  
			currentbankName() {
			if (this.currentbank) {
				return this.currentbank.name;
			}
			return "";
		},

		currentbankAccountName() {
			if (this.currentbank) {
				return this.currentbank.accountName;
			}
			return "";
		},

		currentbankAccountNumber() {
			if (this.currentbank) {
				return this.currentbank.accountnumber;
			}
		},
	},
	methods: {

	
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		getBankById(bid) {
			return this.cashData.find((ele) => ele.id == bid);
		},
		getCurrentsubs() {
			let cp = this.packages.find((ele) => ele.id == this.$route.params.sid);
			return cp.subscriptions.find((ele) => ele.id == this.$route.params.pid);
		},
		getPaymentHref() {
			return (
				"/#/selectpayment/" +
				this.$route.params.pid +
				"/" +
				this.$route.params.sid
			);
		},

		gotoSingin() {
			this.$router.push("/login");
		},
		forgotpassword() {
			this.isActive = true;
			this.showforgotpasswordErr = false;

			if (this.doforgotpassword) {
				var dataToSend = {
					id: this.userid,
				};
				var self = this;
				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("forgetpassword", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setLoader", false);
							self.showforgotpasswordErr = true;
							self.forgotpasswordErr = res.message;
							setTimeout(function() {
								self.$router.push({ name: "login" });
							}, 10000);
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showforgotpasswordErr = true;
						this.forgotpasswordErr = err.response.data.error.message;
					});
			}
		},
		
	},

	data() {
		return {
			checked: false,
			currentSubs: null,
			currentpackages: null,
			currentbank: null,
			currentbankid: null,
			cashData: [
				{
					id: "cp-01",
					name: "First City Monument Bank Plc",
					accountnumber: "2746561011",
					accountName: "ibaka Entertainment Ltd",
				},
				{
					id: "cp-02",
					name: "Fidelity Bank Plc",
					accountnumber: "4010921255",
					accountName: "ibaka Entertainment Ltd",
				},
				{
					id: "cp-03",
					name: "Guaranty Trust Bank Plc",
					accountnumber: "0164370363",
					accountName: "ibaka Entertainment Ltd",
				},
				{
					id: "cp-04",
					name: "Access Bank Plc",
					accountnumber: "0701928191",
					accountName: "ibaka Entertainment Ltd",
				},
				{
					id: "cp-05",
					name: "Zenith Bank Plc",
					accountnumber: "1014114781",
					accountName: "ibaka Entertainment Ltd",
				},
				{
					id: "cp-06",
					name: "Ecobank",
					accountnumber: "0920010254",
					accountName: "ibaka Entertainment Ltd",
				}
			],
			userid: "",
			password: "",
			packages: null,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
<style scoped>
.cursor-pointer {
	cursor: pointer;
}
a.disabled {
	pointer-events: none;
	cursor: default;
}
.pricing-heading {
    color: var(--text-primary-color) !important;
}
.lead{
    color: var(--text-primary-color) !important;
}
</style>
